import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { AbuseThreshold } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class AbuseThresholdService implements HttpService<AbuseThreshold> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<AbuseThreshold[]>> {
        return this.http.get<AbuseThreshold[]>(env.API_URL + '/abuse-thresholds', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    get(id: string) : Observable<HttpResponse<AbuseThreshold>> {
        return this.http.get<AbuseThreshold>(env.API_URL + '/abuse-thresholds/' + id, {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                if (resp.body != null && resp.body.abuse_threshold_id) {
                    /*
                    resp.body.release_date = DateService.toDateString(resp.body.release_date);
                    resp.body.modified_datetime = DateService.toDateString(resp.body.modified_datetime);
                    */
                }
                return resp;
            })
        );
    }

    post(t: AbuseThreshold): Observable<HttpResponse<AbuseThreshold>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    put(t: AbuseThreshold): Observable<HttpResponse<Message>> { 
        //return throwError(() => new Error("Invalid API service call attempt"));
        t = this.sanitize(t);
        return this.http.put<Message>(env.API_URL + '/abuse-thresholds/' + t.abuse_threshold_id, t, {
            params: {},
            observe: 'response'
        });
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    sanitize(t: AbuseThreshold): AbuseThreshold {

        //date
        //t.release_date = DateService.to8601String(t.release_date);
        //number
        t.threshold = parseInt(t.threshold + "");
        //nullable
        //t.middlename = t.middlename == "" ? null : t.middlename;

        return t
    }

}
